export default __webpack_public_path__ + "static/media/ofertaLaboral.3a97cba7.jpeg";